module.exports = __webpack_public_path__ + "img/recourse.7d237acf.png";